import { render, staticRenderFns } from "./QualifiedFoalScore.vue?vue&type=template&id=5428906e&"
import script from "./QualifiedFoalScore.vue?vue&type=script&lang=js&"
export * from "./QualifiedFoalScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports